// DO NOT EDIT! Auto-generated by LayoutFilesGenerator.php

import * as $ from "jquery";
import {Layout} from "../src/ts/layouts/Layout";
import {ArticleLifts} from "./layouts/article_lifts/ArticleLifts";
import {BasicText} from "./layouts/basicText/BasicText";
import {Boxlinks} from "./layouts/boxlinks/Boxlinks";
import {CarouselAndText} from "./layouts/carousel_and_text/CarouselAndText";
import {CTALinks} from "./layouts/cta_links/CTALinks";
import {CTAWithLinks} from "./layouts/cta_with_links/CTAWithLinks";
import {ContentList} from "./layouts/content_list/ContentList";
import {DistributorsList} from "./layouts/distributors_list/DistributorsList";
import {DeeplinkNavigation} from "./layouts/deeplink_navigation/DeeplinkNavigation";
import {DoubleContent} from "./layouts/double_content/DoubleContent";
import {DoubleContentDark} from "./layouts/double_content_dark/DoubleContentDark";
import {DoubleCTA} from "./layouts/double_cta/DoubleCTA";
import {DownloadSoftwareForm} from "./layouts/download_software_form/DownloadSoftwareForm";
import {Downloads} from "./layouts/downloads/Downloads";
import {FAQ} from "./layouts/faq/FAQ";
import {FullscreenImage} from "./layouts/fullscreenImage/FullscreenImage";
import {Hero} from "./layouts/hero/Hero";
import {HeroWithContent} from "./layouts/hero_with_content/HeroWithContent";
import {ImageAndText} from "./layouts/imageAndText/ImageAndText";
import {ImageBig} from "./layouts/imageBig/ImageBig";
import {ImageGallery} from "./layouts/image_gallery/ImageGallery";
import {ImageComparisonSlider} from "./layouts/image_comparison_tool/ImageComparisonSlider";
import {Productlist} from "./layouts/productlist/Productlist";
import {Shortcode} from "./layouts/shortcode/Shortcode";
import {ShortcodeWithSidebar} from "./layouts/shortcode_with_sidebar/ShortcodeWithSidebar";
import {TestimonialLifts} from "./layouts/testimonial_lifts/TestimonialLifts";
import {Videolink} from "./layouts/videoLink/Videolink";
import {VideoBig} from "./layouts/video_big/VideoBig";
import {VideoSquare} from "./layouts/video_square/VideoSquare";
import {Videolist} from "./layouts/video_list/Videolist";


export class Layouts {
	private layouts:Array<Layout>;
	
	constructor() {
		let self = this;
		this.layouts = [];
		
        $(".article-lifts").each(function (index, element) {
            self.layouts.push( new ArticleLifts($(element)) );
        });

        $(".basicText").each(function (index, element) {
            self.layouts.push( new BasicText($(element)) );
        });

        $(".boxlinks").each(function (index, element) {
            self.layouts.push( new Boxlinks($(element)) );
        });

        $(".carousel-and-text").each(function (index, element) {
            self.layouts.push( new CarouselAndText($(element)) );
        });

        $(".cta-links").each(function (index, element) {
            self.layouts.push( new CTALinks($(element)) );
        });

        $(".cta-with-links").each(function (index, element) {
            self.layouts.push( new CTAWithLinks($(element)) );
        });

        $(".content-list").each(function (index, element) {
            self.layouts.push( new ContentList($(element)) );
        });

        $(".distributors-list").each(function (index, element) {
            self.layouts.push( new DistributorsList($(element)) );
        });

        $(".deeplink-navigation").each(function (index, element) {
            self.layouts.push( new DeeplinkNavigation($(element)) );
        });

        $(".double-content").each(function (index, element) {
            self.layouts.push( new DoubleContent($(element)) );
        });

        $(".double-content-dark").each(function (index, element) {
            self.layouts.push( new DoubleContentDark($(element)) );
        });

        $(".double-cta").each(function (index, element) {
            self.layouts.push( new DoubleCTA($(element)) );
        });

        $(".download-software-form").each(function (index, element) {
            self.layouts.push( new DownloadSoftwareForm($(element)) );
        });

        $(".downloads").each(function (index, element) {
            self.layouts.push( new Downloads($(element)) );
        });

        $(".faq").each(function (index, element) {
            self.layouts.push( new FAQ($(element)) );
        });

        $(".fullscreenImage").each(function (index, element) {
            self.layouts.push( new FullscreenImage($(element)) );
        });

        $(".hero").each(function (index, element) {
            self.layouts.push( new Hero($(element)) );
        });

        $(".hero-with-content").each(function (index, element) {
            self.layouts.push( new HeroWithContent($(element)) );
        });

        $(".imageAndText").each(function (index, element) {
            self.layouts.push( new ImageAndText($(element)) );
        });

        $(".imageBig").each(function (index, element) {
            self.layouts.push( new ImageBig($(element)) );
        });

        $(".image-gallery").each(function (index, element) {
            self.layouts.push( new ImageGallery($(element)) );
        });

        $(".image-comparison-tool").each(function (index, element) {
            self.layouts.push( new ImageComparisonSlider($(element)) );
        });

        $(".productlist").each(function (index, element) {
            self.layouts.push( new Productlist($(element)) );
        });

        $(".shortcode").each(function (index, element) {
            self.layouts.push( new Shortcode($(element)) );
        });

        $(".shortcode-with-sidebar").each(function (index, element) {
            self.layouts.push( new ShortcodeWithSidebar($(element)) );
        });

        $(".testimonial-lifts").each(function (index, element) {
            self.layouts.push( new TestimonialLifts($(element)) );
        });

        $(".videoLink").each(function (index, element) {
            self.layouts.push( new Videolink($(element)) );
        });

        $(".video-big").each(function (index, element) {
            self.layouts.push( new VideoBig($(element)) );
        });

        $(".video-square").each(function (index, element) {
            self.layouts.push( new VideoSquare($(element)) );
        });

        $(".video-list").each(function (index, element) {
            self.layouts.push( new Videolist($(element)) );
        });

;
	}

	public getLayouts( className:string ):Layout[]{
		return this.layouts.filter( layout => layout.name() == className );
	}
		
	public getLayout( className:string ):Layout{
		return this.layouts.filter( layout => layout.name() == className )[0];
	}
}